export const LEGITIMATION_STATUSES = [
  "pending",
  "requested",
  "verified",
  "failed",
];

export const LEGITIMATION_STATUS_CONFIG = {
  pending: {
    labelKey: "Pending",
    backgroundColor: "#E9ECEF",
    alertColor: "secondary",
    helperKey:
      "Identity has not been verified yet. Start verification before disclosing personal data.",
  },
  requested: {
    labelKey: "Verification in progress",
    backgroundColor: "#FFF3CD",
    alertColor: "warning",
    helperKey:
      "Verification is in progress. Wait for the data subject to complete the ID check before disclosing data.",
  },
  verified: {
    labelKey: "Identity verified",
    backgroundColor: "#D1E7DD",
    alertColor: "success",
    helperKey:
      "Identity is confirmed. You may proceed with data access or export.",
  },
  failed: {
    labelKey: "Verification failed",
    backgroundColor: "#F8D7DA",
    alertColor: "danger",
    helperKey:
      "Verification failed. Do not disclose personal data. Document the reason in legitimation notes.",
  },
};
